import { Navigate } from "react-router-dom";

export const DevelopmentOnly = ({ children, redirectTo = '/' }: { children: JSX.Element; redirectTo?: string }) => {
  const isDevelopmentEnv = import.meta.env.MODE !== 'production';

  return isDevelopmentEnv? children : <Navigate to={redirectTo} replace />;
};
